import { uri } from '../utils/config';
import { HTTP } from './secure/http';

export const updateOrderOfProducts = async (placeId, categoryId, positions) => {
  if (!placeId || !categoryId || !positions) {
    console.log('NO PLACE ID');
    return;
  }

  await HTTP.post({
    path: `${uri.api}/place/${placeId}/product/${categoryId}/order`,
    data: { positions },
  });
};